import { A2kDesktop } from "./A2kDesktop.js";
window.customElements.define("a2k-desktop", A2kDesktop);
